(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesDialogController', VentamesDialogController);

    VentamesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ventames'];

    function VentamesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ventames) {
        var vm = this;

        vm.ventames = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ventames.id !== null) {
                Ventames.update(vm.ventames, onSaveSuccess, onSaveError);
            } else {
                Ventames.save(vm.ventames, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ventamesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
